import { fabric } from 'fabric';

import { DrawingShape } from '~/core/models';
import theme from '~/theme/theme';

const {
  drawingTool: {
    drawingShape: { stroke },
  },
} = theme.light;

export const setGroupColors = (
  item: fabric.Group,
  color: string,
  activeDrawingShape?: DrawingShape
) => {
  const children = item.getObjects();

  children?.forEach((child) => {
    if (item.data?.inInterior) {
      child.set({
        stroke: color,
        fill: color,
      });
    } else if (item.data.parentName === activeDrawingShape?.canvasObjectName) {
      child.set({
        stroke: stroke.active,
        fill: stroke.active,
      });
    } else {
      child.set({
        stroke: stroke.normal,
        fill: stroke.normal,
      });
    }
  });
};
